import React from 'react';
import './SearchItem.sass';

import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import Pricing from '../pricing/Pricing';

export default function SearchItem({slug, imageSrc, header, price, text}) {
  return (
    <div className="search-item">
      <ChannelLink to={`/service/${slug}`} className="search-item__image">
        <ChannelImage
          src={!!imageSrc.length && imageSrc[0]}
          width={540}
          height={340}
          alt={header}
        />
      </ChannelLink>

      <div className="search-item__content">
        <ChannelLink to={`/service/${slug}`} className="search-item__header">{header}</ChannelLink>
        <span className="search-item__price">
          <Pricing value={price}/>
        </span>
        <p className="search-item__text">{text}</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/searchItem/SearchItem.js